{
  "name": "fido",
  "version": "1.13.0",
  "scripts": {
    "ng": "ng",
    "start": "npm run without-localtunnel",
    "start:intake": "npm run without-localtunnel:intake",
    "build:functions": "cd functions && npm run build",
    "build:iframe-protocol": "ng build iframe-protocol",
    "build:firebase": "ng build firebase",
    "start:local": "concurrently -n \"ng,firebase\" -c \"blue,yellow\" \"ng serve\" \"npm run build:functions && firebase --project fido-dabc6 emulators:start --only auth,functions,firestore,pubsub,storage,eventarc --import local --export-on-exit local\"",
    "without-localtunnel": "concurrently -n \"ng,firebase\" -c \"blue,yellow\" \"ng serve\" \"npm run build:functions && firebase --project fido-dabc6 emulators:start --only auth,functions,firestore,hosting,pubsub,storage,eventarc,extensions --import local --export-on-exit local\"",
    "without-localtunnel:intake": "concurrently -n \"ng,firebase\" -c \"blue,yellow\" \"ng serve intake-widget\" \"npm run build:functions && firebase --project fido-dabc6 emulators:start --only auth,functions,firestore,hosting,pubsub,storage,eventarc,extensions --import local --export-on-exit local\"",
    "with-localtunnel": "concurrently -n \"ng,firebase,tunnel\" -c \"blue,yellow,magenta\" \"ng serve\" \"npm run build:functions && firebase --project fido-dabc6 emulators:start --only auth,functions,firestore,hosting,pubsub,storage,eventarc,extensions --import local --export-on-exit local\" \"npx localtunnel --port 5001 --subdomain fido-kaizen\"",
    "serve": "ng serve",
    "build": "ng build",
    "build:ci": "ng build --progress false",
    "build:intake-widget:ci": "ng build intake-widget --progress false",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test:ci": "npm run test:ci:fido && npm run test:ci:intake-widget && npm run test:ci:iframe-protocol && npm run test:ci:firebase",
    "test:ci:fido": "ng test fido --no-watch",
    "test:ci:intake-widget": "ng test intake-widget --no-watch",
    "test:ci:iframe-protocol": "ng test iframe-protocol --no-watch",
    "test:ci:firebase": "ng test firebase --no-watch",
    "lint": "ng lint",
    "lint:fido": "ng lint fido",
    "lint:intake-widget": "ng lint intake-widget",
    "lint:iframe-protocol": "ng lint iframe-protocol",
    "prepare": "husky",
    "build-themes": "devextreme build",
    "postinstall": "npm run build-themes && node add-devextreme-license",
    "test:rules": "npm --prefix tests/firestore-rules ci && npm --prefix tests/firestore-rules test",
    "test:verify-done": "node --test \"scripts/verify-done/**/*.test.mjs\"",
    "test:e2e": "cross-env E2E_EMULATOR_TIMEOUT_MS=180000 npx playwright test --config=qa/e2e/playwright.config.ts --project=chromium"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "release": {
    "branches": [
      "main"
    ],
    "plugins": [
      "@semantic-release/commit-analyzer",
      "@semantic-release/release-notes-generator",
      "@semantic-release/changelog",
      [
        "@semantic-release/npm",
        {
          "npmPublish": false
        }
      ],
      "@semantic-release/git",
      "@semantic-release/github"
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "^21.2.10",
    "@angular/common": "^21.2.12",
    "@angular/compiler": "^21.2.12",
    "@angular/core": "^21.2.12",
    "@angular/forms": "^21.2.12",
    "@angular/platform-browser": "^21.2.12",
    "@angular/router": "^21.2.12",
    "@fingerprintjs/fingerprintjs-pro-angular": "^2.0.0",
    "devextreme": "^25.2.3",
    "devextreme-angular": "^25.2.3",
    "devextreme-exceljs-fork": "^4.4.4",
    "fido-types": "file:functions/fido-types",
    "file-saver-es": "^2.0.5",
    "firebase": "^12.13.0",
    "jspdf": "^4.0.0",
    "libphonenumber-js": "^1.12.25",
    "ngx-avatars": "^1.10.2",
    "ngx-markdown": "^21.3.0",
    "ngxtension": "^7.0.2",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "uuid": "^13.0.0",
    "xlsx": "^0.18.5",
    "zod": "^4.4.3"
  },
  "devDependencies": {
    "@angular/build": "^21.2.10",
    "@angular/cli": "^21.2.10",
    "@angular/compiler-cli": "^21.2.12",
    "@playwright/test": "^1.58.2",
    "@schematics/angular": "^21.2.10",
    "@semantic-release/changelog": "^6.0.3",
    "@semantic-release/git": "^10.0.1",
    "@types/file-saver-es": "^2.0.3",
    "@types/node": "^25.6.2",
    "@vitest/coverage-v8": "^4.1.6",
    "angular-eslint": "21.3.1",
    "concurrently": "^9.2.1",
    "cross-env": "^7.0.3",
    "devextreme-cli": "^1.12.1",
    "devextreme-schematics": "^1.15.0",
    "devextreme-themebuilder": "^25.2.3",
    "eslint": "^9.39.0",
    "firebase-tools": "^14.27.0",
    "happy-dom": "^20.9.0",
    "husky": "^9.1.7",
    "jsdom": "^29.1.1",
    "ng-packagr": "^21.2.3",
    "prettier": "^3.6.2",
    "typescript": "~5.9.2",
    "typescript-eslint": "8.46.3",
    "vitest": "^4.1.6",
    "yaml": "^2.8.3"
  }
}
